import { LoggerService } from '@ad-lucy/context/LoggerService';
import { useEffect } from 'react';

import { polyfillRandomUUID } from './utils/polyfillRandomUUID';

const logger = LoggerService.getLogger().getModuleLogger(Polyfills.name);

export function Polyfills(): null {
  useEffect(() => {
    polyfillRandomUUID(() => logger.warn('crypto.randomUUID is not supported, applying polyfill'));
  }, []);

  return null;
}
